import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * There is no "home" screen. MSP staff belong in the tenant list; everyone else is scoped to the
 * tenants they have been granted, so the tenant list is still the honest landing place — it simply
 * shows fewer rows.
 */
export const Route = createFileRoute('/')({
  beforeLoad: () => {
    throw redirect({ to: '/tenants' });
  },
});
